import React from 'react';

function NavTop() {
  return (
    <div className="nav-top pt-30 pb-30">
      <div className="container">
        <div className="row">
          <div className="col-md-4 valign">
            <a href="#0" className="logo icon-img-60">
              <img src="/assets/imgs/logo-light.png" alt="Logo" />
            </a>
          </div>

          <div className="col-md-4 valign">
            <div className="social text-center full-width">
              {/* 
              <a href="https://www.behance.net" target="_blank" rel="noreferrer">
                <i className="fab fa-behance"></i>
              </a>
              <a href="https://dribbble.com" target="_blank" rel="noreferrer">
                <i className="fab fa-dribbble"></i>
              </a>
              <a href="https://github.com" target="_blank" rel="noreferrer">
                <i className="fab fa-github"></i>
              </a>
              */}

              {/* ✅ Upwork Icon */}
              <a
                href="https://www.upwork.com/freelancers/hamzawebdeveloper"
                target="_blank"
                rel="noreferrer"
                style={{
                  // background: "transparent", // remove purple circle
                  border: "none",
                  // boxShadow: "none",
                  // display: "inline-block",
                  // padding: "0",
                  // margin: "0 8px",
                }}
              >
                <img
                  src="/assets/imgs/header/upwork.svg"
                  alt="Upwork"
                  width="22"
                  height="22"
                  style={{
                    // filter: "invert(1)", // makes the dark logo white on dark background
                    // opacity: 0.9,        // slight dim to blend with other icons
                    transition: "0.3s",
                    // verticalAlign: "middle",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = 1)}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = 0.9)}
                />
              </a>
            </div>
          </div>

          <div className="col-md-4 valign">
            <div className="full-width info">
              <div className="d-flex justify-content-end">
                <a href="https://leadsnite.com" target="_blank" className="text-right">
                  <span className="sub-title fz-12">leadsnite.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="nav-butn">
          <span className="pe-7s-menu"></span>
        </div>
      </div>
    </div>
  );
}

export default NavTop;
